import {
  BANNER_DESCRIPTION_MAX_LENGTH,
  BANNER_TITLE_MAX_LENGTH,
  PEPIRIS_GUIDELINE_MAX_LENGTH,
  PEPIRIS_IMAGE_MAX_SIZE_BYTES
} from '@/utils/constants/perfectStoreConstants';

export const STRING_SCHEMA = {type: 'string'};

const REQUIRED_RULE = {type: 'required', msg: ' is required'};

const maxLengthRule = (limit) => ({
  type: 'maxLength',
  limit,
  msg: ` must be less than or equal to ${limit} characters`
});

export const pepirisImageSpecText = (dimensions) =>
  `Required: WebP • ${dimensions.width} px × ${dimensions.height} px • RGB • Max. ${PEPIRIS_IMAGE_MAX_SIZE_BYTES / 1024} KB`;

export const pepirisTitleUiSchema = {
  label: 'Title*',
  placeholder: 'Type here',
  isDark: true,
  maxLength: BANNER_TITLE_MAX_LENGTH,
  validationRules: [REQUIRED_RULE, maxLengthRule(BANNER_TITLE_MAX_LENGTH)]
};

export const pepirisDescriptionUiSchema = {
  label: 'Description*',
  placeholder: 'Type here',
  isDark: true,
  showToolbar: false,
  rows: 4,
  maxLength: BANNER_DESCRIPTION_MAX_LENGTH,
  validationRules: [REQUIRED_RULE, maxLengthRule(BANNER_DESCRIPTION_MAX_LENGTH)]
};

export const pepirisGuidelineUiSchema = (index) => ({
  label: `Guideline ${index + 1}*`,
  placeholder: 'Type here',
  isDark: true,
  maxLength: PEPIRIS_GUIDELINE_MAX_LENGTH,
  validationRules: [REQUIRED_RULE, maxLengthRule(PEPIRIS_GUIDELINE_MAX_LENGTH)]
});

export const targetGuidelinesToggleSchema = {
  label: 'Target Guidelines',
  isDark: true,
  showCheckedIcon: false
};

export const photoGuidelinesToggleSchema = {
  label: 'Photo Guidelines',
  isDark: true,
  showCheckedIcon: false
};
